import create from "zustand";
import axios from "axios";
import { NGROK } from "../APIs";
import { myLocalStorage } from "../components/StorageHelper";

let userDataFetchPromise = null;
let userDataFetchEmail = "";
const USER_DATA_MIN_INTERVAL_MS = 60_000;

const useUserStore = create((set, get) => ({  user: {},
  loading: false,
  hasErrors: false,

  azureRedirectURI: "",

  tenantName: "",
  apiKey: "",
  userName: "",
  isCachingEnabled: "",
  activeComputer: null,
  computerId: null,
  defaultTenant: undefined,
  selectedProfile: undefined,
  webUrlDetails: undefined,

  lastSession: {
    email: null,
    latestTenant: null,
    latestComputerId: null,
    latestUserId: null,
    resourceId: null,
    latestPublisherId: null,
    latestAppId: null,
    latestFolderId: null,
    latestGroupId: null,
    latestTenantMode: null,
    latestUsername: null,
  },
  remoteSessionMap: new Map(),

  setAzureRedirectURI: (url) => {
    set((state) => ({
      user: {
        ...state.user,
        azureRedirectURI: url,
      },
    }));
  },

  // later hange
  setUserRole: (role) => {
    set((state) => ({
      user: {
        ...state.user,
        role: role,
      },
    }));
  },

  setApiKey: (key) => {
    set(() => ({ apiKey: key }));
  },
  setTenantName: (name) => {
    set(() => ({ tenantName: name }));
  },
  setDefaultTenant: (tenant) => {
    set(() => ({ defaultTenant: { ...tenant } }));
  },
  setActiveComputer: (computer) => {
    set(() => ({ activeComputer: { ...computer } }));
  },
  setLastSession: (session) => {
    set(() => ({ lastSession: { ...session } }));
  },
  setSelectedProfile: (profile) => {
    set(() => ({ selectedProfile: { ...profile } }));
  },
  setUserName: (name) => {
    set(() => ({ userName: name }));
  },
  setComputerId: (id) => {
    set(() => ({ computerId: id }));
  },
  setisCachingEnabled: (bullean) => {
    set(() => ({ isCachingEnabled: bullean }));
  },
  setWebURLDetails: (webURl) => {
    set(() => ({ webUrlDetails: { ...webURl } }));
  },

  logOut: async (email) => {
    try {
      axios.get(`${NGROK}/api/logout`);
      const map = get().remoteSessionMap;
      map.clear();
    } catch (error) {
      set(() => ({ hasErrors: true }));
    }
  },

  setSessionTab: (key, windowRef) => {
    const oldMap = get().remoteSessionMap;
    const newMap = new Map(oldMap);
    newMap.set(key, windowRef);
    set(() => ({ remoteSessionMap: newMap }));
  },

  closeSessionTab: (key) => {
    const oldMap = get().remoteSessionMap;
    const win = oldMap.get(key);
    if (win && !win.closed) {
      win.close();
    }
    const newMap = new Map(oldMap);
    newMap.delete(key);
    set(() => ({ remoteSessionMap: newMap }));
  },

  getSessionTab: (key) => {
    return get().remoteSessionMap.get(key);
  },

  sessionMinutesLeft: 0,
  setSessionMinutesLeft: (minutes) =>
    set(() => ({ sessionMinutesLeft: minutes })),

  getUserData: async (email, options = {}) => {
    const { silent = false, force = false } = options;
    const emailId = (email || myLocalStorage.getItem("email") || "").toLowerCase();
    if (!emailId) return get().user;

    const currentUser = get().user || {};
    const lastFetchedAt = currentUser._fetchedAt || 0;
    const isFresh =
      !force &&
      currentUser.email === emailId &&
      lastFetchedAt > 0 &&
      Date.now() - lastFetchedAt < USER_DATA_MIN_INTERVAL_MS;

    if (isFresh) {
      return currentUser;
    }

    if (userDataFetchPromise && userDataFetchEmail === emailId) {
      return userDataFetchPromise;
    }

    const hasExistingUser = Boolean(
      currentUser.email || currentUser.userId || currentUser.role,
    );

    if (!silent && !hasExistingUser) {
      set(() => ({ loading: true }));
    }

    const realm = myLocalStorage.getItem("realm") || "";
    const isSsoRealm = realm.includes("-sso");
    const storedRole = myLocalStorage.getItem("role");

    const buildUser = (data) => {
      if (data?.email || data?.userId || data?.role) {
        return {
          ...data,
          email: data.email || emailId,
          role:
            data.role ||
            storedRole ||
            (isSsoRealm ? "TENANT_USER" : undefined),
          _fetchedAt: Date.now(),
        };
      }
      return {
        email: emailId,
        role: storedRole || (isSsoRealm ? "TENANT_USER" : undefined),
        _fetchedAt: Date.now(),
      };
    };

    userDataFetchEmail = emailId;
    userDataFetchPromise = (async () => {
      try {
        const axiosInstance = axios.create();
        const maxAttempts = isSsoRealm && !currentUser.userId ? 2 : 1;
        let data = null;

        for (let attempt = 0; attempt < maxAttempts; attempt++) {
          const response = await axiosInstance.get(
            `${NGROK}/api/check-user?email=${emailId}`,
          );
          data = response.data;
          if (data?.userId || data?.role) {
            break;
          }
          if (attempt < maxAttempts - 1) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }

        const user = buildUser(data);
        set(() => ({ user, loading: false }));
        return user;
      } catch (err) {
        const user = buildUser(null);
        set(() => ({
          user,
          hasErrors: true,
          loading: false,
        }));
        return user;
      } finally {
        userDataFetchPromise = null;
        userDataFetchEmail = "";
      }
    })();

    return userDataFetchPromise;
  },}));
export const fetchUserDataStore = () => useUserStore.getState().getUserData;

export default useUserStore;
